import client from "../../config/client";
import { GET_BUSINESS_ALERT_ROUTING_SETTINGS } from "../../graphql/queries/alertRouting";
import { SAVE_BUSINESS_ALERT_ROUTING_SETTINGS } from "../../graphql/mutations/alertRouting";
import {
  loadBusinessAlertPolicy,
  loadResidentAssignmentsMap,
  saveBusinessAlertPolicyLocal,
  saveResidentAssignmentsMap,
} from "./residentAssignment";

const enabled =
  String(process.env.REACT_APP_ENABLE_ALERT_ROUTING_BACKEND_SYNC || "").toLowerCase() === "true";

function normalizeBusinessId(businessId) {
  if (businessId == null || businessId === "") return null;
  return String(businessId);
}

function safeParseJson(raw, fallback) {
  if (!raw) return fallback;
  if (typeof raw === "object") return raw;
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

export function isAlertRoutingBackendSyncEnabled() {
  return enabled;
}

export async function pullAlertRoutingSettingsFromBackend(businessId) {
  const id = normalizeBusinessId(businessId);
  if (!enabled || !id) {
    return { ok: false, reason: !enabled ? "disabled" : "missing_business_id" };
  }

  try {
    const res = await client.query({
      query: GET_BUSINESS_ALERT_ROUTING_SETTINGS,
      variables: { businessId: id },
      fetchPolicy: "no-cache",
    });

    const payload = res?.data?.getBusinessAlertRoutingSettings;
    if (!payload) {
      return { ok: false, reason: "empty" };
    }

    const policy = safeParseJson(payload?.policyJson, null);
    const assignments = safeParseJson(payload?.residentAssignmentsJson, null);

    if (policy && typeof policy === "object") {
      saveBusinessAlertPolicyLocal(id, policy);
    }
    if (assignments && typeof assignments === "object") {
      saveResidentAssignmentsMap(id, assignments);
    }

    return {
      ok: true,
      policy: policy || loadBusinessAlertPolicy(id),
      assignments: assignments || loadResidentAssignmentsMap(id),
      updatedAt: payload?.updatedAt || null,
    };
  } catch (error) {
    return { ok: false, reason: "query_failed", error };
  }
}

export async function pushAlertRoutingSettingsToBackend({ businessId, policy, assignments = null }) {
  const id = normalizeBusinessId(businessId);
  if (!enabled || !id) {
    return { ok: false, reason: !enabled ? "disabled" : "missing_business_id" };
  }

  const effectivePolicy = policy || loadBusinessAlertPolicy(id) || null;
  const effectiveAssignments = assignments || loadResidentAssignmentsMap(id) || {};

  try {
    const input = {
      businessId: id,
      policyJson: JSON.stringify(effectivePolicy || {}),
      residentAssignmentsJson: JSON.stringify(effectiveAssignments || {}),
    };

    const res = await client.mutate({
      mutation: SAVE_BUSINESS_ALERT_ROUTING_SETTINGS,
      variables: { input },
    });

    const payload = res?.data?.saveBusinessAlertRoutingSettings;
    return { ok: !!payload?.success, payload };
  } catch (error) {
    return { ok: false, reason: "mutation_failed", error };
  }
}
